import { render, staticRenderFns } from "./BusConfigIndex.vue?vue&type=template&id=0f822f55&scoped=true"
import script from "./BusConfigIndex.vue?vue&type=script&lang=js"
export * from "./BusConfigIndex.vue?vue&type=script&lang=js"
import style0 from "./BusConfigIndex.vue?vue&type=style&index=0&id=0f822f55&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f822f55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f822f55')) {
      api.createRecord('0f822f55', component.options)
    } else {
      api.reload('0f822f55', component.options)
    }
    module.hot.accept("./BusConfigIndex.vue?vue&type=template&id=0f822f55&scoped=true", function () {
      api.rerender('0f822f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cfg/BusConfigIndex.vue"
export default component.exports